import { render } from "./raceDetail.vue?vue&type=template&id=4e3b53f2&scoped=true"
import script from "./raceDetail.vue?vue&type=script&lang=js"
export * from "./raceDetail.vue?vue&type=script&lang=js"

import "./raceDetail.vue?vue&type=style&index=0&id=4e3b53f2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e3b53f2"]])

export default __exports__